export default "__VITE_ASSET__PoWszUGh__"